<template>
  <v-app id="inspire">
    <v-main>
      <link
        rel="stylesheet"
        href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css"
      >
      <v-toolbar elevation="0">
            <!-- <v-app-bar-nav-icon /> -->

            <v-layout row class="display-1 ml-2">
                <div id="font">
                    Simples
                </div>

                <div id="font" class="primary--text">
                    Medic
                </div>
            </v-layout>
            <v-spacer />
            <div>
                <v-card  outlined class="rounded-xl">
                    <v-list-item>
                        <v-icon class="mr-2">
                            person
                        </v-icon>
                        <v-list-item-content>
                            <v-list-item-title v-text="nomeFormatado(user.nome)" />
                        </v-list-item-content>
                    </v-list-item>
                </v-card>
            </div>
            <v-btn title="Ajuda" text icon color="primary" @click="retornarHelp()">
                <v-icon title="Ajuda">
                    info
                </v-icon>
            </v-btn>

            <v-btn title="Logout" text icon color="primary" @click="logout()">
                <v-icon v-if="user.tecnico" title="Logout">
                    logout
                </v-icon>
                <v-icon v-else title="Logout">
                    power_settings_new
                </v-icon>
            </v-btn>
        </v-toolbar>
      <v-divider />

      <v-tabs centered>
      <v-tab>Lista de Pacientes</v-tab>
      <v-tab>Histórico de Atendimentos</v-tab>

      <v-tab-item>
        <v-flex class="pa-3 pb-4">
          <!-- {{items}} -->

          <br>
          <v-card>
            <v-card-title>
              <v-toolbar-title>Lista de pacientes que não compareceram</v-toolbar-title>

              <v-spacer />

              <v-text-field
                v-model="search"
                append-icon="search"
                label="Buscar"
                single-line
                hide-details
              />
            </v-card-title>

            <v-data-table
              :headers="headers"
              :expand="expand"
              item-key="dataStatus"
              :items="listaPacientesNaoConsultados"
              :search="search"
              items-per-page-text="Linhas por página"
              :items-per-page-options="[15, 20]"
              no-data-text="Lista vazia"
            >
              <template v-slot:items="props">
                <tr>
                  <td
                    :class="props.item.atendimentos.length ? 'title pointer' : 'title'"
                    @click="props.expanded = !props.expanded"
                  >
                    {{ converterDate(props.item.dataStatus) }}
                  </td>
                  <td
                    :class="props.item.atendimentos.length ? 'title text-truncate pointer' : 'title text-truncate'"
                    @click="props.expanded = !props.expanded"
                  >
                    {{ props.item.nomePaciente }}
                  </td>
                  <td
                    :class="props.item.atendimentos.length ? 'title pointer' : 'title'"
                    @click="props.expanded = !props.expanded"
                  >
                    {{ mapearLetraPrioridade(props.item.prioridade) }}{{ props.item.codigo }}
                  </td>
                  <td
                    :class="props.item.atendimentos.length ? 'title pointer' : 'title'"
                    @click="props.expanded = !props.expanded"
                  >
                    {{ props.item.nomeEspecialidade }}
                  </td>
                  <td
                    :class="props.item.atendimentos.length ? 'title text-truncate pointer' : 'title text-truncate'"
                    @click="props.expanded = !props.expanded"
                  >
                    {{ props.item.nomeExame }}
                  </td>
                  <td
                    v-if="props.item.atendimentos.length "
                    class="title pointer"
                    @click="props.expanded = !props.expanded"
                  >
                    {{ props.item.atendimentos.length }}
                  </td>
                  <td
                    v-else
                    class="title"
                    @click="props.expanded = !props.expanded"
                  >
                    --
                  </td>
                  <td>
                    <v-tooltip left>
                      <template v-slot:activator="{ on }">
                        <!-- <v-btn fab small="" > -->
                        <v-icon
                          medium
                          v-on="on"
                          @click="exibirDialogoRetornarFilaMedico(props.item)"
                        >
                          event_note
                        </v-icon>
                      </template>
                      <span>Reenviar para a lista de atendimento médico</span>
                    </v-tooltip>
                  </td>
                </tr>
              </template>
              <template v-slot:expand="props">
                <div
                  v-for="(atendimento, index) in props.item.atendimentos"
                  :key="index"
                >
                  <v-layout
                    row
                    wrap
                  >
                    <v-flex
                      xs12
                      sm5
                      class="title font-weight-regular pb-1"
                    >
                      {{ atendimento.nomeEspecialidade }}
                    </v-flex>

                    <v-flex
                      xs12
                      sm5
                      class="title font-weight-regular pb-1"
                    >
                      {{ atendimento.nomeExame }}
                    </v-flex>
                  </v-layout>
                </div>
              </template>
              <template v-slot:no-results>
                <v-alert
                  :value="true"
                  color="error"
                  icon="warning"
                >
                  Sua busca por "{{ search }}" não encontrou resultados.
                </v-alert>
              </template>
            </v-data-table>
          </v-card>
        </v-flex>
      </v-tab-item>
      <v-tab-item>
        <v-card class="dialog"  height="1080px">
          <v-row v-if="!isExibirAtendimento" :class="isExibirAtendimento?'animated fadeOut': 'animated fadeIn'">
              <v-col cols="12">
                  <v-layout justify-center>
                      <v-card flat class="mt-1" max-width="700px" color="grey lighten-3" elevation="3">
                      <v-progress-linear color="orange" v-if="load" :indeterminate="true" />
                      <v-date-picker
                          :disabled="load"
                          v-model="date"
                          full-width
                          header-color="green"
                          locale="pt-Br"
                      >
                      </v-date-picker>
                  </v-card>
                  </v-layout>
              </v-col>
          </v-row>
          <v-row v-if="!isExibirAtendimento" :class="isExibirAtendimento?'animated fadeOut': 'animated fadeIn'">
              <v-layout justify-center>
                  <v-card width="700px">
                    <v-card-title dense class="mb-0 mt-0">
                      <v-spacer/>
                      <v-text-field v-model="search" label="Buscar Paciente" append-icon="search"></v-text-field>
                    </v-card-title>
                    <v-divider/>
                      <v-progress-linear color="orange" v-show="load" :indeterminate="true" />
                      <v-card v-if="load" color="grey lighten-4" width="700px">
                        <v-list v-for="i in 4" :key="i">
                          <v-skeleton-loader type="list-item"/>
                          <v-divider/>
                        </v-list>
                      </v-card>
                      <v-list-item v-if="!load && consultas.length == 0">
                        <v-list-item-title>
                              Não foram encontrados atendimentos para esta data
                        </v-list-item-title>
                      </v-list-item>
                      <v-virtual-scroll
                          v-if="!load"
                          :class="load?'animated fadeIn':''"
                          :bench="0"
                          :items="consultasFiltradas"
                          height="250"
                          item-height="80"
                      >
                          <template v-slot:default="{ item }">
                              <v-list-item :key="item.os" :disabled="load" @click="isExibirAtendimento = true, currentSelected = item">
                                <v-list-item-content>
                                  <v-list-item-title>
                                      <strong>{{ item.nomePaciente }}</strong>
                                  </v-list-item-title>                                  
                                  <v-list-item-subtitle>
                                    <b>OS: </b>{{item.os}} <b>ID Paciente:</b> {{ item.idPaciente }}                               
                                  </v-list-item-subtitle>
                                  <v-list-item-subtitle>
                                    <b>Médico(a): </b>{{item.nomeMedico.split(' ')[0]}}
                                  </v-list-item-subtitle>
                                  </v-list-item-content>
                                  <v-list-item-action>
                                    <v-spacer/>
                                    <v-btn icon>
                                      <v-icon small color="primary">
                                        mdi-open-in-new
                                      </v-icon>
                                    </v-btn>
                                  </v-list-item-action>
                              </v-list-item>
                              <v-divider></v-divider>
                          </template>
                  </v-virtual-scroll>
                  </v-card>
              </v-layout>
          </v-row>

          <v-row>
            <v-layout justify-center>
              <v-card flat color="grey lighten-3" v-if="isExibirAtendimento" :class="isExibirAtendimento?'animated fadeIn': 'animated fadeOut'" class="mt-4">
                <historico :ficha="currentSelected" :isProntuario="false" @voltar="isExibirAtendimento = false"/>
              </v-card>
            </v-layout>
          </v-row>
      </v-card>
      </v-tab-item>
    </v-tabs>

    <v-dialog
        v-model="dialogRetornarFilaMedico"
        persistent
        max-width="370"
      >
        <v-card>
          <v-card-title class="headline white--text blue lighten-1">
            Retornar Paciente à fila médica
          </v-card-title>

          <v-card-text>**Este Paciente será reenviado para a lista de Pacientes do médico</v-card-text>

          <v-card-actions>
            <v-spacer />
            <v-btn
              color="green darken-1"
              text="text"
              @click="dialogRetornarFilaMedico = false"
            >
              Cancelar
            </v-btn>
            <v-btn
              color="green darken-1"
              text="text"
              @click="retornarPacienteAFila(paciente)"
            >
              Ok
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-layout
        row
        justify-center
      >
        <v-dialog
          v-model="aguardandoConexao"
          persistent
          width="300"
        >
          <v-card
            color="primary"
            dark
          >
            <v-card-text>
              Aguardando conexão...
              <v-progress-linear
                indeterminate
                color="white"
                class="mb-0"
              />
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <!-- <v-btn color="green darken-1" text @click="dialog = false">Disagree</v-btn> -->
              <!-- <v-btn color="teal light-4"  @click='recarregarDados'>Recarregar dados</v-btn> -->
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
    </v-main>
  </v-app>
</template>

<script>
import { getToken } from '../store/auth'
import apoioService from '../services/apoio.service'
import socketService from '../services/socket.service'
import medicoService from '../services/medico.service'
import historico from '../components/medico/historico.vue'
export default {
  name: 'HomeApoio',
  components: {
    historico
  },
  data () {
    return {
      page: 1,
      expand: false,
      search: '',
      socket: '',
      servicosQueSeraoMandados: '',
      aguardandoConexao: false,
      paciente: '',
      dialogRetornarFilaMedico: false,
      listaPacientesNaoConsultados: [],
      listaPacientesNaoConsultados2: [],
      mensagemNotificacaoSocket: 'default',
      listaServicos: [],
      respostaServidor: false,
      isEditing: true,
      dialog2: false,
      headers: [
        {
          text: 'Data e horário da última chamada',
          align: 'center',
          value: 'dataStatus',
          sortable: true
        },
        {
          text: 'Nome',
          align: 'center',
          sortable: true,
          value: 'nomePaciente'
        },
        {
          text: 'Código',
          align: 'center',
          sortable: true,
          value: 'codigo'
        },
        {
          text: 'Serviço',
          align: 'center',
          value: 'nomeEspecialidade',
          sortable: true
        },
        { text: 'Exame', align: 'center', value: 'nomeExame', sortable: true },
        { text: 'Outros', align: 'center', value: 'nomeExame', sortable: true },
        { text: 'Ações', value: 'name', align: 'center', sortable: false }

      ],
      listaAdministradores: [],
      user: null,
      items: [
        {
          nomeEspecialidade: 'Cardiologia',
          idServico: '1',
          quantVagas: 1,
          idLocal: 1
        },
        {
          nomeEspecialidade: 'Urologia',
          idServico: '3',
          quantVagas: 2,
          idLocal: 2
        },
        {
          nomeEspecialidade: 'Cirugia',
          idServico: '2',
          quantVagas: 10,
          idLocal: 3
        },
        {
          nomeEspecialidade: 'Ultrasom',
          idServico: '15',
          quantVagas: 10,
          idLocal: 4
        },
        {
          nomeEspecialidade: 'Cirugia 3',
          idServico: '31',
          quantVagas: 11,
          idLocal: 5
        },
        {
          nomeEspecialidade: 'Cirugia 4',
          idServico: '22',
          quantVagas: 11,
          idLocal: 6
        }
      ],
      load: false,
      dialog: false,
      date: null,
      consultas: [],
      isExibirAtendimento: false,
      currentSelected: ''
      // search: ''
    }
  },
  mounted () {
    console.log('em mouted apoio...')
    this.user = this.$store.getters.usuario
    if (this.user.tipo != 7) {
      this.$router.push('/login')
      return
    }
    this.retornarPacientesNaoConsultados()
    console.log(this.user)
    this.conectarSocket()
  },
  created () {
    console.log('created...')
  },

  methods: {
    conectarSocket () {
      if (this.user.tipo == 7) {
        this.socket = io.connect(socketService.SOCKET_URL, {
          query: { token: getToken() }
        })
        this.chamarSocket()
      }
    },

    exibirDialogoRetornarFilaMedico (item) {
      this.paciente = item
      this.dialogRetornarFilaMedico = true
    },

    chamarModalConexao () {
      console.log('em chamarModalConexao..')

      if (this.mensagemNotificacaoSocket == 'aguardando conexao') {
        console.log('em if aguardando conex')
        this.aguardandoConexao = true
      }
      if (this.mensagemNotificacaoSocket == 'conectado') {
        this.aguardandoConexao = false
      } else if (this.mensagemNotificacaoSocket == 'desconectado') {
        this.aguardandoConexao = true
      }
    },

    chamarSocket () {
      console.log('em chamar socket...')

      this.socket.on(
        'naoConsultado',
        function (mensagem) {
          console.log('socket add paciente apoio')
          console.log(mensagem)
          this.listaPacientesNaoConsultados.unshift(mensagem)
          // this.mensagemNotificacao = mensagem;
        }.bind(this)
      )

      this.socket.on(
        'connect',
        function (mensagem) {
          this.mensagemNotificacaoSocket = 'conectado'
          this.chamarModalConexao()
        }.bind(this)
      )

      this.socket.on('connect_error', () => {
        this.mensagemNotificacaoSocket = 'aguardando conexao'
        this.chamarModalConexao()
      })

      this.socket.on(
        'disconnect',
        function () {
          this.mensagemNotificacaoSocket = 'desconectado'
          this.chamarModalConexao()
        }.bind(this)
      )
    },

    retornarPacientesNaoConsultados () {
      console.log('em retornar pacientes não consultados..')
      apoioService.apoio
        .retornarPacientesNaoConsultados()
        .then(rsp => {
          console.log('rsp pacient n consultados', rsp.data)
          if (rsp.data != false) {
            this.listaPacientesNaoConsultados = rsp.data
          }
          if (this.listaPacientesNaoConsultados.length) {
            this.organizarListapacientes()
          }
          console.log('aquiiiiii', this.listaPacientesNaoConsultados)
        })
        .catch(err => {
          // handle your error here
          console.log(err)
        })
    },

    organizarListapacientes () {
      var listaPacientesAux = []
      var elementPrincipal = JSON.parse(JSON.stringify(this.listaPacientesNaoConsultados[0]))
      this.$set(elementPrincipal, 'atendimentos', [])
      listaPacientesAux.push(elementPrincipal)
      for (let index = 1; index < this.listaPacientesNaoConsultados.length; index++) {
        const element = this.listaPacientesNaoConsultados[index]
        if (element.idAtendimento != elementPrincipal.idAtendimento) {
          elementPrincipal = this.listaPacientesNaoConsultados[index]
          this.$set(elementPrincipal, 'atendimentos', [])
          listaPacientesAux.push(elementPrincipal)
        } else {
          elementPrincipal.atendimentos.push(element)
        }
      }
      this.listaPacientesNaoConsultados = listaPacientesAux
    },

    retornarPacienteAFila (item) {
      console.log(item)
      // to-do
      const index = this.listaPacientesNaoConsultados.indexOf(item)
      apoioService.apoio
        .retornarPacienteAFila(
          item.idAtendimento,
          item.idLocalMedico,
          item.codigo,
          item.nomeEspecialidade,
          item.nomePaciente,
          item.idServico,
          item.idExame,
          item.idMedico,
          item.nomeExame,
          item.idLocalFixo
        )
        .then(rsp => {
          console.log('rsp oi:', rsp.data)
          if (rsp.data == true) {
            this.listaPacientesNaoConsultados.splice(index, 1)
            this.dialogRetornarFilaMedico = false
          } else {
            confirm('Erro ao reenviar. Tente novamente')
          }
        })
        .catch(err => {
          // handle your error here
          console.log(err)
        })
    },

    retornarListaApoio () {
      console.log('retornar servicos..')

      this.items.forEach(item => {
        // comentar e colocar na resposta de retornar servicos
        item.valorQuantInicial = item.quantVagas
      })

      console.log('em retornar servicos...')
      administradorUnidadeService.administradorUnidade
        .retornarServicosUnidade(this.user.idUnidade)
        .then(rsp => {
          console.log('rsp oi:')
          this.listaServicos = rsp.data.listaServicos
          console.log(rsp.data.listaServicos)
          // console.log(this.listaChamadas);
          // this.servicoTeste = rsp.data
        })
        .catch(err => {
          // handle your error here
          console.log(err)
        })
    },
    mapearLetraPrioridade (prioridade) {
      if (prioridade === 0) {
        return 'C'
      } else if (prioridade === 1) {
        return 'P'
      } else if (prioridade === 2) {
        return 'B'
      } else if (prioridade === 3) {
        return 'A'
      }
      return ''
    },

    converterDate (data) {
      var d = new Date(data)
      var dia = d.getDate().toString()
      var diaF = dia.length == 1 ? '0' + dia : dia
      var mes = (d.getMonth() + 1).toString() // +1 pois no getMonth Janeiro começa com zero.
      var mesF = mes.length == 1 ? '0' + mes : mes
      var anoF = d.getFullYear()

      var minutes = d.getMinutes().toString()
      minutes = minutes.length == 1 ? '0' + minutes : minutes
      var hours = d.getHours().toString()
      hours = hours.length == 1 ? '0' + hours : hours

      return diaF + '/' + mesF + '/' + anoF + ' ' + hours + ':' + minutes
    },
    logout () {
      console.log('em logout..')
      // this.$router.push("/login");
      this.$store
        .dispatch('FedLogOut')
        .then(rsp => {
          console.log('11111111')
          this.socket.close()
          this.$router.push('/login')
          if (r) {
          }
        })
        .catch(error => {
          //   this.progress = false;
          //   this.alert = true;
          //   this.msg = error;
        })
    },
    nomeFormatado (str) {
      var arr = str.split(' ')
      if (arr[1] != null) {
        var preposicao = arr[1].toLowerCase()
        if (
          preposicao == 'de' ||
          preposicao == 'da' ||
          preposicao == 'das' ||
          preposicao == 'do ' ||
          preposicao == 'dos'
        ) {
          preposicao = true
        } else {
          preposicao = false
        }
      }
      return arr.slice(0, preposicao ? 3 : 2).join(' ')
    },
    carregarDataAtual () {
      var now = new Date()
      var year = now.getFullYear()
      var month = String(now.getMonth() + 1).padStart(2, '0')
      var day = String(now.getDate()).padStart(2, '0')
      this.date = `${year}-${month}-${day}`
      console.log('antes de chamar')
    },
    buscarPacientesConsultasPorData () {
      this.load = true
      medicoService.medico.buscarPacientesMedicosConsultasPorData(this.date).then(r => {
        if (r.status == 200) {
        // console.log('VEIO ', r.data)
          this.consultas = r.data
        } else {
          console.log('NAO VEIO')
        }
      }).finally(() => {
        this.load = false
      })
    }
  },
  computed: {
    consultasFiltradas () {
      if (!this.search) {
        console.log('aaaa')
        return this.consultas
      }
      const busca = this.search.toLowerCase()
      return this.consultas.filter(item => {
        const nome = item.nomePaciente.toLowerCase()
        return nome.includes(busca)
      })
    }
  },
  watch: {
    date (val) {
      console.log('WATCH')
      if (val != null) {
        this.buscarPacientesConsultasPorData()
      } else {
      }
    }
  }
}
</script>

<style  scoped>
.md-card {
  width: 320px;
  margin: 4px;
  display: inline-block;
  vertical-align: top;
}

.feedback {
  background-color: #31b0d5;
  color: white;
  padding: 10px 20px;
  border-radius: 4px;
  border-color: #46b8da;
}

#mybutton {
  position: fixed;
  bottom: 20px;
  right: 10px;
}
.input-qty {
  width: 60px;
  height: 25px;
  border: 2px solid #80cbc4;
  border-radius: 5px;
}

.pointer {
  cursor: pointer;
}
</style>
